import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/home/home.page').then((m) => m.HomePage),
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./pages/home/home.page').then((m) => m.HomePage),
  },
  // Backwards-compat: redirect /cases to /pm/cases
  {
    path: 'cases',
    pathMatch: 'full',
    redirectTo: 'pm/cases',
  },
  // Backwards-compat: redirect /cases/:id to /pm/cases/:id
  {
    path: 'cases/:caseId',
    pathMatch: 'full',
    redirectTo: 'pm/cases/:caseId',
  },
  {
    path: 'callback',
    loadComponent: () =>
      import('./_shared/components/get-token/get-token.component').then(
        (m) => m.GetTokenComponent,
      ),
  },
  {
    path: 'search',
    loadComponent: () =>
      import('./pages/search/search.page').then((m) => m.SearchPage),
  },
  {
    path: 'research-book/:id',
    loadComponent: () =>
      import('./pages/research-book/research-book-detail/research-book-detail.component').then(
        (m) => m.ResearchBookDetailComponent,
      ),
  },
  {
    path: 'research-book',
    loadComponent: () =>
      import('./pages/research-book/research-book-dashboard/research-book-dashboard.component').then(
        (m) => m.ResearchBookDashboardComponent,
      ),
  },
  {
    path: 'data-explorer',
    loadComponent: () =>
      import('./pages/data-explorer/data-explorer.page').then(
        (m) => m.DataExplorerPage,
      ),
  },
  {
    path: 'judgement/:court/:fileId',
    loadComponent: () =>
      import('./pages/view-judgement/view-judgement.page').then(
        (m) => m.ViewJudgementPage,
      ),
  },
  // Practice Management (single folder: app/practice-management)
  {
    path: 'pm',
    loadChildren: () =>
      import('./practice-management/practice-management.module').then(
        (m) => m.PracticeManagementModule,
      ),
  },
  // Calendar — top-level module, sibling of practice-management
  {
    path: 'calendar',
    loadChildren: () =>
      import('./calendar/calendar.module').then((m) => m.CalendarModule),
  },
  // Document Management System (DMS) - lazy-loaded from dms/dms.routes.ts
  {
    path: 'dms',
    loadChildren: () => import('./dms/dms.routes').then((m) => m.DMS_ROUTES),
  },
  // Firm Workspace (S1 — foundation)
  {
    path: 'firm',
    loadChildren: () =>
      import('./firm-workspace/firm-workspace.routes').then(m => m.FIRM_WORKSPACE_ROUTES),
  },

  {
    path: 'onboarding/create-workspace',
    loadComponent: () =>
      import('./onboarding/create-workspace/create-workspace.page').then((m) => m.CreateWorkspacePage),
  },
  {
    path: 'accept-invite/:token',
    loadComponent: () =>
      import('./accept-invite/accept-invite.page').then((m) => m.AcceptInvitePage),
  },
  {
    path: 'profile',
    loadComponent: () =>
      import('./pages/profile/profile.page').then((m) => m.ProfilePage),
  },
  {
    path: 'subscription',
    loadComponent: () =>
      import('./pages/subscription/subscription.page').then((m) => m.SubscriptionPage),
  },
  {
    path: 'change-password',
    loadComponent: () =>
      import('./pages/change-password/change-password.page').then((m) => m.ChangePasswordPage),
  },
  {
    path: 'phonepe-callback',
    loadComponent: () =>
      import('./pages/phonepe-callback/phonepe-callback.page').then((m) => m.PhonepeCallbackPage),
  },
  {
    path: 'google-calendar/callback',
    loadComponent: () =>
      import('./pages/google-calendar-callback/google-calendar-callback.component').then(
        (m) => m.GoogleCalendarCallbackComponent,
      ),
  },
  {
    path: 'outlook-calendar/callback',
    loadComponent: () =>
      import('./pages/outlook-calendar-callback/outlook-calendar-callback.component').then(
        (m) => m.OutlookCalendarCallbackComponent,
      ),
  },
];

export const AppRoutingModule = RouterModule.forRoot(routes, {
  preloadingStrategy: PreloadAllModules,
});
